/**
 * DevExtreme (viz/vector_map.js)
 * Version: 19.2.6
 * Build date: Thu Jan 30 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
"use strict";
module.exports = require("./vector_map/vector_map");
module.exports.default = module.exports;



//////////////////
// WEBPACK FOOTER
// ./~/devextreme/viz/vector_map.js
// module id = 1403
// module chunks = 0